import React from "react";
import LegalLayout from "./LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout
      title="Refund & Cancellation Policy"
      updated="February 2026"
      testId="page-refund"
    >
      <h2>1. Cancel anytime</h2>
      <p>
        ScanMint is a month-to-month service. There are <strong>no long-term
        contracts</strong> and no cancellation fees. You can cancel from the
        Settings screen or by contacting support at{" "}
        <a href="mailto:support@scanmint.app">support@scanmint.app</a>. Once you
        cancel, no further monthly charges will be issued for the affected
        property.
      </p>

      <h2>2. Monthly usage charges ($1.00 per active car, volume-discounted)</h2>
      <ul>
        <li>
          ScanMint charges <strong>$1.00 per active car per month</strong>{" "}
          for the first 199 cars, with automatic volume discounts at 200
          cars ($0.90 each), 500 cars ($0.85 each), and a custom quote for
          properties with 1000+ cars.
        </li>
        <li>
          <strong>First month free:</strong> The 30 days immediately
          following payment of the $99 setup fee are free of monthly
          charges. Recurring monthly billing begins after the free period.
        </li>
        <li>
          Monthly usage is prepaid. The current billing period is{" "}
          <strong>not prorated</strong> upon cancellation — your QR codes remain
          active for the period you have already paid for.
        </li>
        <li>
          Refunds for monthly usage charges are generally not provided once the
          billing period has started, except where required by law or in cases
          of confirmed double-billing or platform error.
        </li>
      </ul>

      <h2>3. $99 setup fee</h2>
      <ul>
        <li>
          The <strong>$99 one-time setup fee</strong> covers onboarding, the
          printer kit, sticker supply, and welcome packet that we ship to you.
        </li>
        <li>
          The setup fee is <strong>refundable within 14 days</strong> of payment{" "}
          <em>only</em> if your physical sticker kit has not yet been shipped.
          Once the kit ships, the setup fee becomes non-refundable because the
          materials are produced and dispatched specifically for your property.
        </li>
        <li>
          If your sticker kit arrives damaged or never arrives, contact support
          and we will replace the kit at no additional cost.
        </li>
      </ul>

      <h2>4. Suspension for unpaid invoices</h2>
      <p>
        If an invoice remains unpaid past its grace period, QR access for the
        affected property may be <strong>suspended</strong>. Suspension does
        not cancel your account, and stored data is preserved. Service is
        restored automatically once the outstanding balance is paid. Repeated
        non-payment may result in account termination, in which case stored
        data may be deleted as described in our Privacy Policy.
      </p>

      <h2>5. How to request a refund</h2>
      <p>
        To request a refund, email{" "}
        <a href="mailto:support@scanmint.app">support@scanmint.app</a> from the
        billing email on file and include your property name and the invoice or
        payment date. We aim to respond within 5 business days. Approved
        refunds are returned to the original payment method through Stripe;
        ACH refunds may take several additional business days to settle.
      </p>

      <h2>6. Changes to this policy</h2>
      <p>
        We may update this Refund &amp; Cancellation Policy from time to time.
        Material changes will be announced through the dashboard or by email.
      </p>
    </LegalLayout>
  );
}
